import type { IStatusConfig, IStatusProps } from 'shared/ui/Status'
import type { ITenDLCStatus, ITenDLCStatusName } from 'entities/Compliance'
import { type ITenDLCClientStatus } from './type'

const pendingReviewStatus: IStatusProps = {
  title: 'Pending review',
  icon: 'clock',
  emphasis: 'high',
  intent: 'informative',
}

const inCarrierReviewStatus: IStatusProps = {
  title: 'In carrier review',
  icon: 'clock',
  emphasis: 'high',
  intent: 'informative',
}

export const tenDLCStatusConfig: Record<ITenDLCStatusName, IStatusProps> = {
  empty: {
    title: 'Empty',
    icon: 'minusCircle',
    emphasis: 'high',
    intent: 'neutral',
  },
  approved: {
    title: 'Approved',
    icon: 'check2',
    emphasis: 'high',
    intent: 'positive',
  },
  failed: {
    title: 'Rejected',
    icon: 'closeCircle',
    emphasis: 'high',
    intent: 'negative',
  },
  rejected_by_twilio: {
    title: 'Rejection (Twilio)',
    icon: 'closeCircle',
    emphasis: 'high',
    intent: 'negative',
  },
  rejected_by_tcr: {
    title: 'Rejection (TCR)',
    icon: 'closeCircle',
    emphasis: 'high',
    intent: 'negative',
  },
  rejected_by_admin: {
    title: 'Rejection (internal)',
    icon: 'closeCircle',
    emphasis: 'high',
    intent: 'negative',
  },
  expired: {
    title: 'Expired',
    icon: 'closeCircle',
    emphasis: 'high',
    intent: 'negative',
  },
  internal_review: {
    title: 'Internal review',
    icon: 'clock',
    emphasis: 'high',
    intent: 'purple',
  },
  pending: {
    title: 'Pending',
    icon: 'clock',
    emphasis: 'high',
    intent: 'informative',
  },
  under_review: {
    title: 'In carrier review',
    icon: 'clock',
    emphasis: 'high',
    intent: 'informative',
  },
  pending_review: pendingReviewStatus,
  twilio_review: {
    title: 'Twilio review',
    icon: 'clock',
    emphasis: 'high',
    intent: 'informative',
  },
  tcr_review: {
    title: 'TCR review',
    icon: 'clock',
    emphasis: 'high',
    intent: 'informative',
  },
  share_added: {
    title: 'Share request',
    icon: 'clock',
    emphasis: 'high',
    intent: 'informative',
  },
  share_request_accepted: {
    title: 'Share Request Accepted',
    icon: 'clock',
    emphasis: 'high',
    intent: 'informative',
  },
  vendor_import_started: {
    title: 'Twilio import review',
    icon: 'clock',
    emphasis: 'high',
    intent: 'informative',
  },
  vetting_upgrade_tcr_review: {
    title: 'Vetting upgrade TCR review',
    icon: 'clock',
    emphasis: 'high',
    intent: 'informative',
  },
  vetting_upgrade_approved: {
    title: 'Vetting upgrade approved',
    icon: 'check2',
    emphasis: 'high',
    intent: 'positive',
  },
  in_progress: pendingReviewStatus,
}

export const tenDLCClientConfig: Record<ITenDLCClientStatus, IStatusProps> = {
  ...tenDLCStatusConfig,
  in_carrier_review: inCarrierReviewStatus,
  share_added: inCarrierReviewStatus,
  accepted: inCarrierReviewStatus,
  vendor_import_started: inCarrierReviewStatus,
}

const tenDLCBusinessProfileStatuses: Array<ITenDLCStatus> = [
  'empty',
  'internal_review',
  'pending',
  'twilio_review',
  'approved',
  'failed',
  'rejected_by_twilio',
  'rejected_by_admin',
]
const tenDLCBrandStatuses: Array<ITenDLCStatus> = [
  'empty',
  'internal_review',
  'pending',
  'twilio_review',
  'tcr_review',
  'vetting_upgrade_tcr_review',
  'approved',
  'failed',
  'rejected_by_twilio',
  'rejected_by_tcr',
  'rejected_by_admin',
]
const tenDLCCampaignStatuses: Array<ITenDLCStatus> = [
  'empty',
  'internal_review',
  'pending',
  'twilio_review',
  'tcr_review',
  'share_added',
  'vendor_import_started',
  'approved',
  'failed',
  'rejected_by_twilio',
  'rejected_by_tcr',
  'rejected_by_admin',
]

const getConfig = (statuses: Array<ITenDLCStatus>) =>
  statuses.reduce<IStatusConfig>((acc, item) => {
    if (item && tenDLCStatusConfig[item]) {
      return { ...acc, [item]: tenDLCStatusConfig[item] }
    }
    return acc
  }, {})

export const tenDLCBusinessProfileStatusConfig = getConfig(tenDLCBusinessProfileStatuses)
export const tenDLCBrandStatusConfig = getConfig(tenDLCBrandStatuses)
export const tenDLCCampaignStatusConfig = getConfig(tenDLCCampaignStatuses)

export enum tenDLCQuickFilterStatus {
  all = 'all',
  rejected = 'rejected',
  internal_review = 'internal_review',
  empty = 'empty',
  custom = 'custom',
}
